<template>
  <div>
    <multi-select
        :id="id"
        :name="name"
        v-model="computedValue"
        :placeholder="placeholder"
        :value="computedValue"
        @update:model-value="onInput"
        :options="options"
        :label="label"
        :track-by="trackBy"
        :multiple="true" >
    </multi-select>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name : 'multiple-selector',
  components: {
    'multi-select' : Multiselect
  },
  props: {
    id : {
      type: String
    },
    name : {
      type: String
    },
    placeholder : {
      type: String
    },
    label : {
      type: String
    },
    trackBy : {
      type: String
    },
    selectedValues: {

    }
  },
  computed: {
    computedValue: function () {
      if (this.value !== '') {
        return this.value;
      }
      //si las opciones son objetos y hay un valor seleccionado por defecto,
      //construimos un objeto como valor por defecto
      if (typeof this.selectedValues == 'object' && this.trackBy != undefined) {
        let computedValue = [];
        for (let key in this.selectedValues) {
          let selectedValue = this.selectedValues[key];
          for (let optionKey in this.options) {
            for (let prop in this.options[optionKey]) {
              if (prop == 'id' && this.options[optionKey][prop] == selectedValue) {
                computedValue.push(this.options[optionKey]);
              }
            }
          }

        }
        return computedValue;
      }
      return this.selectedValues;
    }
  },
  methods: {
    onInput: function (event) {
      this.value =  event;
      //si las opciones son objetos solo notificamos el valor de la propiedad 'id'
      let eventData = [];
      for (let key in event) {
        if (event[key]['id'] != undefined) {
          eventData.push(event[key]['id']);
        } else {
          eventData.push(event[key]);
        }
      }
      this.$emit('update', eventData);
    }
  },
  data () {
    return {
      value: '',
      options: []
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>